import "./Pride.css";
import prideimg from "./../../assets/1.png";
const Pride = () => {
  return (
    <div className="Pride">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <img src={prideimg} alt="image" />
          </div>
          <div className="col-md-6 ">
            <h2>
              We pride ourselves on making real food from the best ingredients.
            </h2>
            <p>
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Debitis
              rem tenetur eaque?
            </p>
            <button>learn more</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pride;
